import liveServerStatus from '../../liveServerStatus';

/**
 * Generate HTML email content for email migration notification
 * @param {Object} employeeData - Employee information
 * @param {String} oldEmail - Old email address
 * @param {String} newEmail - New email address
 * @returns {String} - HTML content for the email
 */
const generateEmailMigrationHTML = (employeeData, oldEmail, newEmail) => {
  const employeeName = employeeData.name || employeeData.firstName || 'Team Member';
  
  // Add test environment indicator if not in live environment
  const testEnvironmentBanner = !liveServerStatus ? `
    <div style="background-color: #ffeb3b; color: #333; text-align: center; padding: 5px; font-weight: bold; font-size: 12px;">
      ⚠️ TEST EMAIL - No action required ⚠️
    </div>
  ` : '';
  
  return `
    ${testEnvironmentBanner}
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; color: #333;">
      <div style="background-color: #4f46e5; padding: 20px; text-align: center; border-radius: 5px 5px 0 0;">
        <h1 style="color: white; margin: 0;">MyelinZ Email Migration</h1>
      </div>
      
      <div style="border: 1px solid #ddd; border-top: none; padding: 20px; border-radius: 0 0 5px 5px;">
        <p style="font-size: 16px;">Hello ${employeeName},</p>
        
        <p>We're migrating all company email addresses from <strong>myelinh.com</strong> to <strong>myelinz.com</strong> domain.</p>
        
        <div style="background-color: #f5f5f5; padding: 15px; border-radius: 5px; margin: 20px 0;">
          <p style="margin: 0 0 10px 0; font-weight: bold;">Your email has been updated:</p>
          <p style="margin: 0;">Previous: <span style="color: #666;">${oldEmail}</span></p>
          <p style="margin: 5px 0 0 0;">New: <span style="color: #4f46e5; font-weight: bold;">${newEmail}</span></p>
        </div>
        
        <p>Your profile has been created with the new email address. You can now use your new email to log in to all company systems.</p>
        
        <p>For any questions or issues, please contact the IT team.</p>
        
        <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #eee; font-size: 14px; color: #666;">
          <p>Best regards,<br>MyelinZ Team</p>
          ${!liveServerStatus ? '<p><strong>TEST ENVIRONMENT - No action required</strong></p>' : ''}
        </div>
      </div>
    </div>
  `;
};

export default generateEmailMigrationHTML; 